// USER useSwrGetSearchPackAggregatedDetails ***************************************************************************
// pathname: /v1/search-pack/aggregated-details/{jobSlug}
// ************************************************************************************************
import {
  useSwrApi,
} from 'src/hooks/useSwrApi';


interface SearchPackAggregatedProps {
  locale: string,
  jobSlug: string
  shouldFetch?: boolean,

}


/**
 * @description SWR: fetch user resume comments.
 * * **locale**: string - the locale to use for the request. Default 'ro'.
 * * **jobSlug**: string - the job slug for which we need the details
 */
export const useSwrGetSearchPackAggregatedDetails = (props: SearchPackAggregatedProps) => {
  // Props destructuring
  const {
    locale = 'ro',
    jobSlug,
    shouldFetch = true,
  } = props;


  // SWR: fetch data
  // ********************************************
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiSchema<'AggregatedSearchPackData'>>({
    url: `/v1/search-pack/aggregated-details/${jobSlug}`,
    locale,
    shouldFetch,
    apiOptions: {
      revalidateOnMount: true,
      revalidateOnFocus: true,
      dedupingInterval: 0,
    },
    toastsOptions: {
      showErrorToast: true,
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
